export class QuantityHelpers {
  /**
   * Get the price for a photo at a given quantity
   * and size
   * @param {Object} size The size object from the state
   * @param {Object} deliveryOption The delivery object from the state
   * @param {Boolean} fallback Whether or not to fallback to a quantity of one if a size is missing
   * @returns {Number} The non-decimal price
   */
  static priceAtQuantityForSize(size, deliveryOption, fallback) {
    const quantityForSize = QuantityHelpers.quantityForSize(size) || (fallback ? 1 : 0);
    const priceBreaks = [];
    const prices = size.prices[deliveryOption.key];

    // Get price breaks points into an array
    for (const key in prices) {
      if (prices.hasOwnProperty(key)) {
        priceBreaks.push(parseInt(key, 10));
      }
    }

    // Sort priceBreaks low to high and find value at next lowest price break
    return priceBreaks
      .sort((a, b) => a - b)
      .reduce((acc, priceBreak) => {
        return quantityForSize >= priceBreak
          ? prices[priceBreak]
          : acc;
      }, 0);
  }

  /**
   * Get the quantity of all the photos for a given size
   * @param {Object} size The size object from the state
   * @returns {Number} The quantity at a size
   */
  static quantityForSize(size) {
    return (size.photos || []).reduce((acc, photo) => acc + (parseInt(photo.quantity, 10) || 0), 0);
  }
}
